/**
 * SnipeySnipe — main entry point.
 * Registers routes, initializes PWA, sets up network monitoring.
 */

import './styles/base.css';
import './styles/components.css';

import { router } from './router.js';
import { renderHome } from './components/home.js';
import { renderAddAsset } from './components/add-asset.js';
import { renderCheckout } from './components/checkout.js';
import { renderCheckin } from './components/checkin.js';
import { renderEditAsset } from './components/edit-asset.js';
import { renderSettings } from './components/settings-page.js';
import { renderQueueEdit } from './components/queue-edit.js';
import { renderBrowse } from './components/browse.js';
import { initQueueSheet } from './components/queue-sheet.js';

// ── Register routes ──
router
  .on('/', () => renderHome())
  .on('/add-asset', () => renderAddAsset())
  .on('/checkout', () => renderCheckout())
  .on('/checkin', () => renderCheckin())
  .on('/edit-asset', () => renderEditAsset())
  .on('/settings', () => renderSettings())
  .on('/browse', () => renderBrowse())
  .on('/queue-edit/:id', ({ id }) => renderQueueEdit(id));

// ── Initialize ──
router.start();
initQueueSheet();
initNetworkMonitor();
registerServiceWorker();

// ── Network status monitor ──
function initNetworkMonitor() {
  const banner = document.getElementById('network-status');

  function update() {
    if (navigator.onLine) {
      banner.classList.add('hidden');
      document.body.classList.remove('offline');
    } else {
      banner.classList.remove('hidden');
      document.body.classList.add('offline');
    }
  }

  window.addEventListener('online', update);
  window.addEventListener('offline', update);
  update();
}

// ── Service Worker registration ──
function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          console.log('SW registered, scope:', reg.scope);
        })
        .catch((err) => {
          console.warn('SW registration failed:', err);
        });
    });
  }
}
